import moment from 'moment';
import constants from "../../../utils/constants.js";

const columns = [
	{
		id: 'email',
		name: 'Email',
		sortable: true,
		selector: row => row.email,
		cell: row => row.email,
		width: '300px'
	}, {
		id: 'display_name',
		name: 'Display Name',
		sortable: true,
		selector: row => row.display_name,
		cell: row => row.display_name,
		width: '200px'
	}, {
		id: 'account_name',
		name: 'Account',
		sortable: true,
		selector: row => row.account_name,
		cell: row => row.account_name,
		width: '200px'
	}, {
		id: 'is_external',
		name: 'Type',
		sortable: true,
		selector: row => row.is_external,
		cell: row => row.is_external ? 'External' : 'Internal',
		width: '100px'
	}, {
		id: 'last_login',
		name: 'Last Login',
		sortable: true,
		selector: row => row.last_login,
		cell: row => moment(row.last_login).format(constants.DATETIME_FOTMAT),
		width: '200px'
	}, {
		id: 'registration_date',
		name: 'Registration Date',
		sortable: true,
		selector: row => row.registration_date,
		cell: row => !row.is_external ? '-' : row.registration_date ? moment(row.registration_date).format(constants.DATETIME_FOTMAT) : 'Pending',
		width: '200px'
	}, {
		id: 'is_enabled',
		name: 'Status',
		sortable: true,
		selector: row => row.is_enabled,
		width: '160px'
	}, {
		id: 'cloud_db_name',
		name: 'Cloud Database',
		sortable: true,
		selector: row => row.cloud_db_name,
		cell: row => row.cloud_db_name || 'Default',
		width: '1fr'
	}
];

export default columns;
